/*
  Confirmation après l'envoi d'un formulaire de demande (2026-10-14, proposition 3 validée par Vincent).
  Shopify recharge la page avec le message de réussite (form.posted_successfully?) : l'encart
  « Votre demande est bien envoyée » remplace les champs et la page s'y positionne. Aucun effet sur l'envoi.
*/
(function () {
  function setup(done) {
    var form = done.closest('form');
    if (form) form.classList.add('plmf-is-sent');
    var card = done.closest('.plmf, .prestation-contact') || done;

    var again = done.querySelector('[data-plmf-again]');
    if (again && form) again.addEventListener('click', function () {
      form.classList.remove('plmf-is-sent');
      done.hidden = true;
      card.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var first = form.querySelector('input:not([type=hidden]), textarea');
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 400);
    });

    // Positionnement sur l'encart (après les autres scripts de la page) puis mise en évidence.
    setTimeout(function () {
      try { done.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { done.scrollIntoView(); }
      done.focus({ preventScroll: true });
      done.classList.add('is-shown');
    }, 250);

    // Téléphone : fenêtre qui monte du bas, « Parfait, merci » la ferme (l'encart reste en place).
    var modal = form ? form.querySelector('[data-plmf-modal]') : null;
    if (!modal || !window.matchMedia('(max-width: 749px)').matches || typeof modal.showModal !== 'function') return;
    function closeModal() {
      modal.classList.add('is-closing');
      setTimeout(function () {
        modal.classList.remove('is-closing');
        if (modal.open) modal.close();
        document.documentElement.classList.remove('plmf-lock');
      }, 200);
    }
    modal.querySelectorAll('[data-plmf-close]').forEach(function (b) { b.addEventListener('click', closeModal); });
    modal.addEventListener('cancel', function (e) { e.preventDefault(); closeModal(); });
    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    setTimeout(function () {
      modal.showModal();
      document.documentElement.classList.add('plmf-lock');
    }, 450);
  }

  // Calendrier des pages de prestation : jour J entouré, dates passées grisées (affichage seulement).
  function markCalendar(grid) {
    var now = new Date();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
    grid.querySelectorAll('.prestation-date-picker__day').forEach(function (b) {
      var p = (b.getAttribute('aria-label') || '').split('/');
      if (p.length !== 3) return;
      var t = new Date(+p[2], +p[1] - 1, +p[0]).getTime();
      b.classList.toggle('is-today', t === today);
      b.classList.toggle('is-past', t < today);
      if (t < today) b.setAttribute('aria-disabled', 'true');
    });
  }

  /* ---------- Analyse marketing pour le formulaire Contact (2026-10-14) ----------
     Les pages de prestation envoyaient déjà leurs événements ; le formulaire partagé (accueil, Contact, Tarifs, pages
     locales) envoie maintenant aussi « demande envoyée » (plm_form_success), rattaché à la séance choisie, avec la
     provenance de la visite (mêmes clés de session que les pages de prestation). Coordonnées hachées par le serveur. */
  var MKT_ENDPOINT = 'https://pascaline-cockpit-y4hpujkaaq-ew.a.run.app/api/marketing-event';
  var TRACKED = ['gclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  function ss(key, value) {
    try { if (value === undefined) return sessionStorage.getItem(key) || ''; sessionStorage.setItem(key, value); } catch (e) { return ''; }
  }
  /* Appareil interne (2026-10-22, brief de Vincent) : marqueur persistant `plm_internal=1` (cookie 2 ans + localStorage),
     posé au déverrouillage du cockpit ou par `?interne=1` sur n'importe quelle page (`?interne=0` le retire). Un appareil
     marqué n'envoie ni visite, ni clic, ni parcours ; ses demandes créent le prospect avec le badge « Test interne ». */
  function marqueurInterne() {
    var v = new URLSearchParams(location.search).get('interne');
    try {
      if (v === '1') { document.cookie = 'plm_internal=1; path=/; max-age=63072000; SameSite=Lax'; localStorage.setItem('plm_internal', '1'); }
      else if (v === '0') { document.cookie = 'plm_internal=; path=/; max-age=0; SameSite=Lax'; localStorage.removeItem('plm_internal'); }
      else if (localStorage.getItem('plm_internal') === '1' && !/(?:^|;\s*)plm_internal=1/.test(document.cookie)) {
        document.cookie = 'plm_internal=1; path=/; max-age=63072000; SameSite=Lax'; // cookie effacé : repris du localStorage
      }
    } catch (e) {}
    return /(?:^|;\s*)plm_internal=1/.test(document.cookie);
  }
  var INTERNE = marqueurInterne();
  function rememberVisit() {
    if (INTERNE) return;
    var params = new URLSearchParams(location.search);
    TRACKED.forEach(function (k) { var v = params.get(k); if (v) ss('plm_' + k, v.slice(0, 180)); });
    if (!ss('plm_referrer') && document.referrer) {
      try { if (new URL(document.referrer).hostname !== location.hostname) ss('plm_referrer', document.referrer.slice(0, 500)); } catch (e) {}
    }
    if (!ss('plm_client_session_id')) ss('plm_client_session_id', 'pls_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 12));
    // Parcours de la visite (2026-10-21) : adresses des pages vues (20 au plus), envoyées seulement avec une demande
    // (« plm_form_success ») pour la fiche prospect. Rien d'autre n'est envoyé : aucune requête de plus par page.
    var parcours = [];
    try { parcours = JSON.parse(ss('plm_parcours') || '[]'); } catch (e) {}
    if (!Array.isArray(parcours)) parcours = [];
    var path = location.pathname.slice(0, 120);
    if (parcours[parcours.length - 1] !== path && parcours.length < 20) { parcours.push(path); ss('plm_parcours', JSON.stringify(parcours)); }
  }
  // Visiteur gardé par ce navigateur (rattache une demande à la pub d'une visite précédente) et empreinte de l'appareil
  // (écran, langue, fuseau, système : transformée en code anonyme par le Cockpit). Ajout du 2026-10-23.
  function plmVisiteur() {
    try {
      var v = localStorage.getItem('plm_visitor_id');
      if (!v) { v = 'plv_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 12); localStorage.setItem('plm_visitor_id', v); }
      return v;
    } catch (e) { return ''; }
  }
  function plmAppareil() {
    try { return [screen.width + 'x' + screen.height, window.devicePixelRatio || 1, new Date().getTimezoneOffset(), navigator.language || '', navigator.platform || '', navigator.maxTouchPoints || 0].join('|'); } catch (e) { return ''; }
  }
  function trackSharedForm() {
    document.querySelectorAll('.plmf form').forEach(function (form) {
      form.addEventListener('submit', function () {
        var fd = new FormData(form);
        ss('plm_shared_lead', JSON.stringify({
          name: String(fd.get('contact[Nom et Prénom]') || '').trim(),
          email: String(fd.get('contact[email]') || '').trim(),
          phone: String(fd.get('contact[Numéro de téléphone]') || '').replace(/\D/g, ''),
          shooting: String(fd.get('contact[Shooting souhaité]') || ''),
          at: Date.now()
        }));
      });
      if (!form.querySelector('[data-plmf-done]')) return;
      var lead = null;
      try { lead = JSON.parse(ss('plm_shared_lead') || 'null'); } catch (e) {}
      if (!lead || !lead.shooting || Date.now() - lead.at > 30 * 60 * 1000) return;
      if (INTERNE) { try { sessionStorage.removeItem('plm_shared_lead'); } catch (e) {} return; }
      try { sessionStorage.removeItem('plm_shared_lead'); } catch (e) {}
      var payload = {
        event_id: 'ple_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 12),
        event: 'plm_form_success',
        prestation_page: lead.shooting === 'Pack Grossesse + Naissance' ? 'grossesse' : lead.shooting.toLowerCase(),
        page_path: location.pathname,
        client_session_id: ss('plm_client_session_id'),
        visitor_id: plmVisiteur(), appareil: plmAppareil(),
        referrer: ss('plm_referrer'),
        parcours: ss('plm_parcours'),
        location: 'formulaire-contact',
        lead_email: lead.email, lead_phone: lead.phone, lead_name: lead.name
      };
      TRACKED.forEach(function (k) { payload[k] = ss('plm_' + k); });
      try {
        fetch(MKT_ENDPOINT, { method: 'POST', mode: 'cors', cache: 'no-store', keepalive: true, headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(payload) }).catch(function () {});
      } catch (e) {}
    });
  }

  function start() {
    rememberVisit();
    trackSharedForm();
    document.querySelectorAll('[data-plmf-done]').forEach(setup);
    document.querySelectorAll('[data-date-days]').forEach(function (grid) {
      markCalendar(grid);
      if ('MutationObserver' in window) new MutationObserver(function () { markCalendar(grid); }).observe(grid, { childList: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Formulaire Contact (2026-10-21) : « Pack Grossesse + Naissance : paiement en 2 fois » quand Grossesse ou Naissance est choisie. */
(function () {
  function maj(form) {
    var tag = form.querySelector("[data-plmf-2fois]"); if (!tag) return;
    var c = form.querySelector("input[name='contact[Shooting souhaité]']:checked");
    tag.hidden = !(c && (c.value === "Grossesse" || c.value === "Naissance" || c.value === "Pack Grossesse + Naissance"));
  }
  document.addEventListener("change", function (e) {
    if (e.target && e.target.name === "contact[Shooting souhaité]") maj(e.target.form || document);
  });
  document.querySelectorAll("[data-plmf-2fois]").forEach(function (t) { maj(t.closest("form") || document); });
})();

/* Formulaire Contact (2026-10-21, campagne « séance naissance ») : « Date prévue d'accouchement » obligatoire quand
   « Grossesse » est choisie. Sélecteur limité à aujourd'hui → + 9,5 mois ; date passée = message doux vers la séance
   naissance. Envoi : date en toutes lettres + date ISO (champs cachés, actifs seulement pour une grossesse). */
(function () {
  var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  function iso(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  // Grossesse : aujourd'hui → + 9,5 mois. Naissance (pack ou séance seule) : bébé peut être né depuis 2 mois.
  function bornes(naissance) { var a = new Date(); a.setHours(0, 0, 0, 0); var b = new Date(a); b.setDate(b.getDate() + 290); if (naissance) a.setDate(a.getDate() - 60); return [a, b]; }
  function estNaissance(box) { return box.getAttribute('data-mode') === 'naissance'; }
  function verifier(box) {
    var input = box.querySelector('[data-plmf-terme-input]'), ne = box.querySelector('[data-plmf-terme-ne]'), aide = box.querySelector('[data-plmf-terme-aide]');
    var texte = box.querySelector('[data-plmf-terme-texte]'), isoIn = box.querySelector('[data-plmf-terme-iso]');
    var nais = estNaissance(box), v = input.value, b = bornes(nais), passe = false, msg = '';
    texte.value = ''; isoIn.value = '';
    if (v) {
      var d = new Date(v + 'T12:00:00');
      if (isNaN(d.getTime())) msg = 'Indiquez une date valide.';
      else if (d < b[0]) { if (nais) msg = 'Cette date est trop ancienne : vérifiez-la.'; else { passe = true; msg = 'Cette date est déjà passée : votre bébé est peut-être déjà né.'; } }
      else if (d > b[1]) msg = 'Cette date semble lointaine : vérifiez l’année de votre terme.';
      else { texte.value = d.getDate() + ' ' + MOIS[d.getMonth()] + ' ' + d.getFullYear(); isoIn.value = v; }
    }
    input.setCustomValidity(msg);
    ne.hidden = !passe; aide.hidden = passe;
    box.classList.toggle('is-invalid', Boolean(msg) && !passe);
  }
  function maj(form) {
    var box = form.querySelector('[data-plmf-terme]'); if (!box) return;
    var c = form.querySelector("input[name='contact[Shooting souhaité]']:checked");
    var on = Boolean(c && (c.value === 'Grossesse' || c.value === 'Naissance' || c.value === 'Pack Grossesse + Naissance'));
    var nais = Boolean(c && c.value === 'Naissance');
    box.setAttribute('data-mode', nais ? 'naissance' : 'grossesse');
    var lab = box.querySelector('[data-plmf-terme-label]'), aideTxt = box.querySelector('[data-plmf-terme-aide]');
    if (lab) lab.textContent = nais ? 'Terme prévu ou date de naissance *' : 'Date prévue d’accouchement *';
    if (aideTxt) aideTxt.textContent = nais ? 'Indiquez votre terme prévu, ou la date de naissance si bébé est déjà là : je vous proposerai le meilleur moment pour sa séance.' : 'Indiquez votre terme prévu : je vous proposerai les dates les plus adaptées à votre grossesse.';
    var input = box.querySelector('[data-plmf-terme-input]'), b = bornes(nais);
    input.min = iso(b[0]); input.max = iso(b[1]);
    box.hidden = !on; input.required = on;
    box.querySelectorAll('[data-plmf-terme-texte], [data-plmf-terme-iso]').forEach(function (h) { h.disabled = !on; });
    if (on) verifier(box); else input.setCustomValidity('');
  }
  document.addEventListener('change', function (e) {
    var t = e.target; if (!t) return;
    if (t.name === 'contact[Shooting souhaité]') maj(t.form || document);
    if (t.matches && t.matches('[data-plmf-terme-input]')) verifier(t.closest('[data-plmf-terme]'));
  });
  document.addEventListener('input', function (e) { if (e.target && e.target.matches && e.target.matches('[data-plmf-terme-input]')) verifier(e.target.closest('[data-plmf-terme]')); });
  document.addEventListener('click', function (e) {
    var bt = e.target && e.target.closest && e.target.closest('[data-plmf-terme-naissance]'); if (!bt) return;
    var form = bt.closest('form'), r = form && form.querySelector("input[name='contact[Shooting souhaité]'][value='Naissance']");
    if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); r.focus(); }
  });
  document.querySelectorAll('[data-plmf-terme]').forEach(function (b) { maj(b.closest('form') || document); });
})();
